var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalmClinicalBadge = function SvgCalmClinicalBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.315 10.043c-.452.656-1.194 1.01-2.043 1.01-1.753 0-2.86-1.354-2.86-3.064 0-1.666 1.128-3.054 2.892-3.054.785 0 1.527.377 1.892.893l.839-.645C10.475 4.409 9.347 4 8.304 4 5.992 4 4.25 5.613 4.25 7.99c0 2.343 1.677 4.01 4.01 4.01 1.334 0 2.313-.57 2.904-1.376l-.85-.581Z"
  })));
};
export default SvgCalmClinicalBadge;